import Axios from "../../Config/API";
import {
    IContatoEfetivo,
    IContatoNaoEfetivo,
    IResultadoContato,
    ITentativaContato,
} from "../../../Interfaces/Cobranca/ResultadoContato/ResultadoContatoInterface";
import Service from "../../Service";

export async function ListarResultadoContatoService() {
    return Service(
        Axios.get<Array<IResultadoContato>>(
            `/cobranca/resultadocontato/listarresultadocontato`
        )
    );
}

export async function GetResultadoContatoService(idResultadoContato: number) {
    return Service(
        Axios.get(
            `/cobranca/resultadocontato/getresultadocontato?idResultadoContato=${idResultadoContato}`
        )
    );
}

export async function InserirResultadoContatoService(
    requestBody: IResultadoContato
) {
    return Service(
        Axios.post(
            `/cobranca/resultadocontato/inserirresultadocontato`,
            requestBody
        )
    );
}

export async function AtualizarResultadoContatoService(
    requestBody: IResultadoContato
) {
    return Service(
        Axios.put(
            `/cobranca/resultadocontato/atualizarresultadocontato`,
            requestBody
        )
    );
}

export async function DeletarResultadoContatoService(
    idResultadoContato: number
) {
    return Service(
        Axios.delete(
            `/cobranca/resultadocontato/deletarresultadocontato?idResultadoContato=${idResultadoContato}`
        )
    );
}

export async function InserirTentativaDeContatoService(
    requestBody: ITentativaContato
) {
    return Service(
        Axios.post(
            `/cobranca/resultadocontato/inserirtentativadecontato`,
            requestBody
        )
    );
}

export async function InserirContatoNaoEfetivoService(
    requestBody: IContatoNaoEfetivo
) {
    return Service(
        Axios.post(
            `/cobranca/resultadocontato/inserircontatonaoefetivo`,
            requestBody
        )
    );
}

export async function InserirContatoEfetivoService(
    requestBody: IContatoEfetivo,
    agrupar: boolean
) {
    return Service(
        Axios.post(
            `/cobranca/resultadocontato/inserircontatoefetivo?TipoContatoEfetivo=${
                !agrupar ? "N_AGRUPAR_PARCELAS" : "AGRUPA_PARCELAS"
            }`,
            requestBody
        )
    );
}
